// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","711":"component---src-pages-mdx-slug-js","883":"component---src-pages-404-js","976":"dd833c054ac44fc065c1430e4e13dd9714f600e2"}[chunkId] + "-" + {"678":"3c38a10a7674d7f3d639","711":"b7a1474027eada09edb6","883":"30c7349e95826cfd6d66","976":"5507d21b4ff4f89908f8"}[chunkId] + ".js";
};